import type { ComponentProps } from 'react';

/**
 * Tarjeta con el marcado de la Power App (`src/components/ui/card.tsx`), sin `cn` ni Radix: las clases de
 * quien la usa se añaden al final.
 */
/** Superficie de la tarjeta (borde, radio y fondo), para aplicarla a un elemento que no es un `Card`. */
export const CARD_SURFACE = 'rounded-xl border border-border bg-card text-card-foreground';

/**
 * `flush` quita el relleno vertical y el hueco entre hijos, para una tabla o lista pegada a los bordes; recorta
 * el contenido contra las esquinas. Es una prop y no `className="py-0"` porque en Tailwind no gana la clase
 * escrita al final: con `py-5` y `py-0` a la vez, el relleno seguía.
 */
export function Card({ className = '', flush = false, ...props }: ComponentProps<'div'> & { flush?: boolean }) {
  const layout = flush ? 'flex flex-col gap-0 overflow-hidden' : 'flex flex-col gap-5 py-5';
  return <div className={`${layout} ${CARD_SURFACE} ${className}`} {...props} />;
}

export function CardHeader({ className = '', ...props }: ComponentProps<'div'>) {
  return <div className={`grid auto-rows-min items-start gap-1.5 px-5 ${className}`} {...props} />;
}

/** Título de la tarjeta; aquí es un encabezado (`h2`) para que se pueda navegar por él. */
export function CardTitle({ className = '', ...props }: ComponentProps<'h2'>) {
  return <h2 className={`text-base leading-none font-semibold tracking-tight ${className}`} {...props} />;
}

export function CardContent({ className = '', ...props }: ComponentProps<'div'>) {
  return <div className={`px-5 ${className}`} {...props} />;
}
